<div [class]="containerClass">
  <label for="startingTime" class="form-label" [class]="labelClass">{{labelText}}</label>
  <select id="startingTime" [(ngModel)]="selection" [class]="selectClass"
    [disabled]="dropdownDisabled!">
    @for (dropdownValue of dropdownValues; track dropdownValue) {
      <option [ngValue]="dropdownValue?.minutes">{{dropdownValue.label}}</option>
    }
  </select>
</div>
